import { useSEO, generateWebPageSchema, generateBreadcrumbSchema, generateServiceSchema } from '@/utils/seo';
import ServicePageLayout, { ServicePageConfig } from '@/pages/service-common/ServicePageLayout';

/* ─── Hero Background ─── */
const HERO_IMG = 'https://readdy.ai/api/search-image?query=Elegant%20abstract%20golden%20human%20resources%20icons%20and%20team%20silhouettes%20on%20deep%20navy%20blue%20background%20minimal%20sophisticated%20high-end%20corporate%20aesthetic%20soft%20glowing%20particles%20no%20text&width=1920&height=800&seq=hrhero1&orientation=landscape';

const config: ServicePageConfig = {
  pageLabel: '人材・HRコンサルティング',
  heroImage: HERO_IMG,
  tag: 'HR Consulting',
  title: <>ハイパフォーマンス組織を<br />構築する人材戦略</>,
  subtitle: '優秀な人材の採用・育成・定着を実現する包括的なHR戦略。生成AIを活用した次世代の組織設計で、競争力ある人材基盤を構築します。',
  icon: 'ri-user-heart-line',
  services: [
    { icon: 'ri-user-search-line', title: '採用戦略最適化', desc: '採用プロセスを最適化し、競争の激しい市場でも優秀な人材を確実に獲得します。' },
    { icon: 'ri-graduation-cap-line', title: '学習・能力開発', desc: '生成AIも活用したトレーニングプログラムとキャリアパスを設計します。' },
    { icon: 'ri-trophy-line', title: 'パフォーマンス管理', desc: '公正で効果的な評価システムを構築し、組織全体の成果を引き出します。' },
    { icon: 'ri-organization-chart', title: '組織設計', desc: '最適なパフォーマンスを発揮するチーム構造と役割設計を実現します。' },
    { icon: 'ri-heart-pulse-line', title: '文化・エンゲージメント', desc: '優秀人材が長く活躍できる魅力的な職場文化と従業員体験を設計します。' },
    { icon: 'ri-refresh-line', title: '変革マネジメント', desc: '組織変革をスムーズに推進し、従業員の変化への適応を支援します。' },
  ],
  benefits: [
    '競争の激しい市場で優秀な人材を採用・定着させる仕組みを構築',
    '従業員エンゲージメントと生産性を同時に向上させる職場環境を実現',
    '全階層でのリーダーシップ開発により、組織の持続的成長を支援',
    '変化に素早く対応できるアジャイルな組織体制を構築',
    '生成AIを活用した人材育成で、社員のスキルを飛躍的に向上',
    '人材への投資を最大化し、長期的な企業競争力を強化',
  ],
};

export default function HRConsultingPage() {
  useSEO({
    title: '東京 人材・HRコンサルティング TradFit株式会社 | 組織設計・人材戦略',
    description: 'TradFit株式会社の人材・HRコンサルティングサービス。採用・育成・定着を実現する包括的なHR戦略で、競争力ある人材基盤を構築します。',
    keywords: 'HRコンサルティング, 人材戦略, 組織設計, 採用支援, 東京',
    path: '/hr-consulting',
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        generateWebPageSchema('人材・HRコンサルティング | TradFit株式会社', 'TradFit株式会社の人材・HRコンサルティングサービス。', '/hr-consulting'),
        generateBreadcrumbSchema([{ name: 'ホーム', path: '/' }, { name: '事業内容', path: '/business' }, { name: '人材・HRコンサルティング', path: '/hr-consulting' }]),
        generateServiceSchema('人材・HRコンサルティング', '採用・育成・定着を実現する包括的なHRコンサルティングサービス。'),
      ],
    },
  });
  return <ServicePageLayout config={config} />;
}
